import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../image/other-bg.png'


const _withScopeId = n => (_pushScopeId("data-v-605af02f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "parther" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "parther_title" }, "合作单位", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "parther_tip" }, "感谢大家支持", -1))
const _hoisted_4 = { class: "parther_container" }
const _hoisted_5 = { class: "parther_main" }
const _hoisted_6 = { class: "partherItem" }
const _hoisted_7 = { class: "partherItem_name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "parther_img",
  src: _imports_0
}, null, -1))

import { Autoplay } from 'swiper'
import { Swiper, SwiperSlide, } from 'swiper/vue/swiper-vue.js';
import { ref } from 'vue';
import { Swiper as SwiperType } from 'swiper/types';

export default /*#__PURE__*/_defineComponent({
  __name: 'Partner',
  setup(__props) {

const a = require('../image/logo/china-protection.png');
const list = ref([

  { url: require('../image/partner/nanling.png'), name: '广东南岭国家级自然保护区' },
  { url: require('../image/partner/china.png'), name: '广东省科学院动物研究所' },
  { url: require('../image/partner/china.png'), name: '广东石门台国家级自然保护区' },
  { url: require('../image/partner/china.png'), name: '广东始兴南山省级自然保护区' },
  { url: require('../image/partner/china.png'), name: '广东陆河南万省级自然保护区' },
  { url: require('../image/partner/china.png'), name: '广东阳春鹅凰嶂省级自然保护区' },
  { url: require('../image/partner/china.png'), name: '广东惠东古田省级自然保护区' },
  { url: require('../image/partner/china.png'), name: '广东杨东山十二度水省级自然保护区' },

  { url: require('../image/partner/china.png'), name: '广东罗坑鳄蜥国家级自然保护区' },
  { url: require('../image/partner/china.png'), name: '广东从化陈禾洞省级自然保护区' },
  { url: require('../image/partner/china.png'), name: '广东乐昌大瑶山省级自然保护区' },
  { url: require('../image/partner/china.png'), name: '广东省科学院地理研究所' },
  { url: require('../image/partner/china.png'), name: '广东阳春百涌省级自然保护区' },
  { url: require('../image/partner/china.png'), name: '广东省乳阳林场' },
  { url: require('../image/partner/china.png'), name: '广东省沙头角林场' },
  { url: require('../image/partner/china.png'), name: '广东杨东山十二度水省级自然保护区' },

  { url: require('../image/partner/nanling.png'), name: '广东江门古兜山省级自然保护区' },
  { url: require('../image/partner/nanling.png'), name: '广东佛冈观音山省级自然保护区' },

  { url: require('../image/partner/nanling.png'), name: '广东紫金白溪省级自然保护区' },
  { url: require('../image/partner/china.png'), name: '广西壮族自治区森林资源与生态环境监测中心' },
  { url: require('../image/partner/china.png'), name: '广西壮族自治区防城金花茶国家级自然保护区' },
  { url: require('../image/partner/china.png'), name: '广西桂林花坪国家级自然保护区' },
  { url: require('../image/partner/encheng.jpg'), name: '广西恩城国家级自然保护区' },

  { url: require('../image/partner/nanling.png'), name: '福建汀江源国家级自然保护区' },

])
const moduleList = ref([Autoplay])

const handleProgress = (swiper: SwiperType, progress: number) => {
  swiper.slides.forEach((item: any, index) => {
    const slideProgress = item.progress;
    let modify = 1;
    if (Math.abs(slideProgress) > 1) {
      modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
    }
    let translate = (slideProgress * modify * 100) + 'px';
    let scale = 1 - Math.abs(slideProgress) / 5
    let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
    item.style.transform = `scale(${scale})`;
    //item.style.fontSize = `${scale * 50}px`
    item.style.zIndex = zIndex;
    item.style.opacity = 1;
    if (Math.abs(slideProgress) >= 5) {
      item.style.opacity = 0;
    }
  })
}
const handleSetTransition = (swiper: SwiperType, transition: number) => {
  swiper.slides.forEach((item: any) => {
    item.style.transitionDuration = `${transition}ms`
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(Swiper), {
          direction: 'vertical',
          modules: moduleList.value,
          freeMode: true,
          autoplay: { delay: 0 },
          speed: 500,
          loop: true,
          "slides-per-view": "auto",
          "watch-slides-progress": true,
          "centered-slides": true,
          "space-between": 30,
          allowTouchMove: false,
          "looped-slides": 7,
          onProgress: handleProgress,
          onSetTransition: handleSetTransition
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["modules"])
      ])
    ]),
    _hoisted_8
  ]))
}
}

})